import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthApi } from '../hooks/use-auth-api';

const AdminRoute: React.FC = () => {
  const { isAuthenticated, isAdmin, isLoading } = useAuthApi();

  if (isLoading) {
    return <div className="loading">در حال بارگذاری...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return isAdmin ? <Outlet /> : <Navigate to="/" replace />;
};

export default AdminRoute;